import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Box from '@mui/material/Box';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
// import SendIcon from '@mui/icons-material/Send';
import emailjs from "@emailjs/browser";

import Button from '@mui/material/Button';
import "./contact.style.css";

const Contact = () => {
    const sendForm = (e) => {
        e.preventDefault();
        
        emailjs.sendForm("service_gpwns6e", "template_2tfxtja", e.target, '5RoaEMrH0HU2MznT8').then(
            () => {
              alert("Email Submitted!");
              window.location.reload();
            },
            (error) => {
              console.error("Failed to send email:", error);
              alert("Failed to send email.");
            }
          );

      }

  return (
    <div className='contact'>
      <div className='pageTitle'>
        <h4>Contact</h4>
      </div>
      <div className='content'>
        <Container>
            <Row>
                <Col lg={12}>
                <div style={{backgroundColor:"#F5F5F5", padding: 30, borderRadius: 20, marginBottom: 20}}>
                    <h2 className='mb-4' style={{color:"#BC252A", fontFamily: "Ponomar"}}><b>Pakistan Oil Mills (Pvt) ltd.</b></h2>
                    <p ><b>Head Office: </b> Tower ‘B’, 12th Floor, Fortuna Tower, 431-A, PECHS, Block-6, Main Shahra-e-Faisal, Karachi.</p>
                    <p ><b>Tel: </b> 021-34549643 - 48</p>
                    <hr />
                    <p ><b>Factory: </b> Plot No. P/5-B, SITE, Kotri.</p>
                    <p ><b>Tel: </b> 022-3871100, 3871200, 3871300, 3871400, 3871500, 3871600, 3871700</p>
                    <p ><b>Email: </b> <a style={{fontFamily: "Ponomar", textDecoration: "none"}} href="mailto:info@pakistanoilmills.com">info@pakistanoilmills.com</a></p>
                    <p ><b>Website: </b> <a style={{fontFamily: "Ponomar", textDecoration: "none"}} href="http://www.pakistanoilmills.com" target="_blank">www.pakistanoilmills.com</a></p>
                </div>

                </Col>
                <Col lg={6}>
                    <div className='map'>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.713156974923!2d68.28151917505676!3d25.3474046776146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x394c7b1da5204a37%3A0xdb45d2fb9a549b31!2sPakistan%20Oil%20Mills%20(Pvt.)%20Ltd!5e0!3m2!1sen!2s!4v1742897612617!5m2!1sen!2s" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>

                </Col>
                <Col lg={6}>
                    <div className='form'>
                        <h1>Hava a Talk!</h1>
                        <form  onSubmit={sendForm}>
                            <Row>
                                <Col lg={12}>
                                    <div className="input d-flex align-items-center ">
                                            <TextField
                                                required
                                                id="standard-required"
                                                label="Name"
                                                name='name'
                                                fullWidth
                                                variant="filled"
                                                />

                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="input d-flex align-items-center ">
                                            <TextField
                                                required
                                                fullWidth
                                                id="standard-required"
                                                label="Email"
                                                name='email'
                                                variant="filled"
                                                />
                                        
                                    </div>
                                </Col>

                                <Col lg={12}>
                                    <div className="input d-flex align-items-center ">
                                            <TextField
                                                id="standard-multiline-static"
                                                label="Message"
                                                fullWidth
                                                multiline
                                                rows={4}
                                                name='message'
                                                // defaultValue="Default Value"
                                                variant="filled"
                                                />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="input d-flex align-items-center ">
                                    <Button variant="contained" type='submit' fullWidth>
                                        Submit
                                    </Button>
                                    </div>
                                </Col>
                            </Row>

                        </form>
                    </div>
                </Col>
            </Row>
        </Container>
      </div>
    </div>
  )
}

export default Contact
